import React from "react";
import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { PlaneView } from "../PlaneView";
import { PilotView } from "../../pilot/PilotView";
import { ActiveGlider } from "../ActiveGlider";

/**
 * Component for the configuration button in the header
 */
export const ConfigButton = ({ active, onConfigClick, setNavigationType }) => {
  const { towingPlane, lifter, glider, first, second, reel, towTask } = active;
  const showConf = reel || towingPlane || lifter || glider || first || second;

  return (
    <IonCol size="8" onClick={onConfigClick}>
      <div className="big-button">
        {showConf ? (
          <IonGrid>
            <IonRow>
              <IonCol>
                {reel ? (
                  <span>Naviják</span>
                ) : (
                  <>
                    <PlaneView plane={towingPlane} />
                    <br />
                    <PilotView pilot={lifter} />
                  </>
                )}
              </IonCol>
              <IonCol>
                {!(towTask?.onlyTow) ? (
                  <ActiveGlider
                    glider={glider}
                    first={first}
                    second={second}
                    activeSelectFce={setNavigationType}
                  />
                ) : (
                  <span>Úloha pouze pro vlečnou ({towTask.name})</span>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
        ) : (
          <h2 className="text-center">Konfigurace</h2>
        )}
      </div>
    </IonCol>
  );
};

